module.exports = __webpack_public_path__ + "img/電気回路_5_8_5.3159ee82.png";